/**
 * Mobile - Cart management.
 */

// Imports
import GlobalVars from '../common/GlobalVars';
import AjaxURL from '../common/AjaxURL';
import {
  init as initialInit,
  getItemsCount,
  hasItems,
  updateSkusList,
  addItem,
  addItems,
  removeItem,
} from '../common/Cart';
import {
  triggerCartUpdateEvent,
  cartItemAddedEventName,
  cartItemRemovedEventName,
} from '../common/Events';
import {
  get as getCart,
  set as setCart,
} from './MobileCart';
import cartQuickLinkId from '../common/molecule/cart-items';

function updateCart() {
  $.ajax({
    url: AjaxURL.getbag,
    data: {
      task: 'getbagskus',
      c: GlobalVars.C,
      l: GlobalVars.L
    },
    dataType: 'json',
    type: 'post',
  }).done((asResponse) => {
    let isSuccess = false;

    try {
      isSuccess = asResponse.success;

      if (isSuccess === true && typeof asResponse.data !== 'undefined') {
        setCart(asResponse.data);
      } else if (isSuccess === false && typeof asResponse.error !== 'undefined') {
        throw new Error(asResponse.error);
      }
    } catch (e) {
      console.error('Parsing error:', e);
    } finally {
      triggerCartUpdateEvent(isSuccess, $(`#${cartQuickLinkId}`));
    }
  }).fail(() => {
    triggerCartUpdateEvent(false);
  });
}

function init() {
  initialInit();

  updateSkusList(getCart());

  $(document).on(`${cartItemAddedEventName} ${cartItemRemovedEventName}`, updateCart);
}

// Named exports - Functions
export {
  init,
  getItemsCount,
  hasItems,
  updateSkusList,
  addItem,
  addItems,
  removeItem,
};



// WEBPACK FOOTER //
// ./js/mobile/Cart.js